var map = {
	"./Cisco.png": 6381,
	"./L&T.png": 2173,
	"./L&T2.png": 4565,
	"./NTT Data.png": 7772,
	"./accenture.png": 909,
	"./adobe.png": 5888,
	"./amazon.png": 6122,
	"./atos syntel.png": 1785,
	"./capgemini.png": 8170,
	"./cognizant.png": 8938,
	"./cyient.png": 2015,
	"./dell.png": 4414,
	"./ericsson.png": 2731,
	"./facebook.png": 7397,
	"./genpact.png": 125,
	"./google.png": 4709,
	"./hcl.png": 2516,
	"./hexaware.png": 975,
	"./hp.png": 3559,
	"./infosys.png": 8262,
	"./intel.png": 1599,
	"./itc.png": 7999,
	"./liferay.png": 2169,
	"./linkdin.png": 1783,
	"./microsoft.png": 3048,
	"./mindfire.png": 3784,
	"./mindtree.png": 8800,
	"./mphasis.png": 3620,
	"./niit.png": 9080,
	"./nokia.png": 809,
	"./oracle.png": 8097,
	"./paytm.png": 4911,
	"./persistent.png": 1534,
	"./rolta.png": 6666,
	"./sap.png": 9916,
	"./sonata.png": 1283,
	"./tata.png": 3520,
	"./tcs.png": 7744,
	"./techmahindra.png": 9050,
	"./twitter.png": 885,
	"./virtusa.png": 8391,
	"./wipro.png": 5658,
	"./wns.png": 541,
	"./zensar.png": 9021,
	"./zoho.png": 1933
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 250;